/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa';
import SocialMediaLinks from './SocialMediaLinks';
import LanguageSelector from './LanguageSelector';
import LocalizedLink from './LocalizedLink';
import { usePageContext } from '../contexts/page-context';
import navLinks from '../data/nav-links';
import siteMetadata from '../siteMetadata';

const MobileMenu = ({ isVisible, className, itemsClassname, onSelectedItem = () => {} }) => {
  const {
    pageContext: { shortLang, lang },
  } = usePageContext();

  const [links, setLinks] = useState(navLinks);
  const [backLinks, setBackLinks] = useState(null);
  const [menuLabel, setMenuLabel] = useState(null);

  if (!navLinks) {
    return null;
  }

  const onClick = ({ link, parentLinks }) => {
    setMenuLabel(link.label);
    setLinks(link.children);
    setBackLinks(parentLinks);
  };

  const onSelectedLink = key => {
    setLinks(navLinks);
    setBackLinks(null);
    setMenuLabel(null);
    onSelectedItem(key);
  };

  const onBackLink = () => {
    setMenuLabel(null);
    setLinks(backLinks);
    setBackLinks(null);
  };

  return (
    <div
      className={`menu absolute min-h-screen w-screen lg:hidden left-0 top-0 flex flex-col bg-white text-left overflow-hidden transform duration-300 z-20 ${className} ${
        isVisible ? '' : '-translate-x-full'
      }`}
    >
      <div className="flex py-4 px-4 text-center w-full text-xl capitalize">
        {backLinks && (
          <button type="button" className="-mx-4 absolute" onClick={() => onBackLink()}>
            <div className="flex items-center px-4">
              <FaAngleLeft size={32} />
            </div>
          </button>
        )}
        <div className="flex flex-1 py-1 capitalize justify-center items-center text-base">
          {menuLabel ? menuLabel[shortLang] : lang === siteMetadata.defaultLang ? 'menu' : 'menú'}
        </div>
      </div>
      <nav className="flex flex-col">
        {links.map(l =>
          l.children ? (
            <button
              type="button"
              key={l.key}
              onClick={() => onClick({ link: l, parentLinks: links })}
              className={`relative flex items-center py-8 px-4 no-underline border-light-500 border-t border-solid text-xl uppercase ${itemsClassname}`}
            >
              <div className="flex justify-center items-center text-center w-full">
                <div>{l.label[shortLang]}</div>
              </div>
              <div className="flex justify-end w-full absolute right-4">
                <FaAngleRight size="24" />
              </div>
            </button>
          ) : (
            <LocalizedLink
              key={l.key}
              onClick={() => onSelectedLink(l.key)}
              className={`flex justify-center text-center py-8 px-4 no-underline border-light-500 border-t border-solid text-xl uppercase ${itemsClassname}`}
              to={l.link}
            >
              {l.label[shortLang]}
            </LocalizedLink>
          ),
        )}
      </nav>
      <div className="border-light-500 border-t border-solid lg:hidden">
        <div className="flex flex-row justify-center items-center -ml-4 pl-4 py-4">
          <SocialMediaLinks size={32} className="p-4 flex items-center text-light-500" />
          <div className="flex flex-none mx-2">
            <LanguageSelector className="text-2xl" onSelected={() => onSelectedItem()} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
